import { LoanControllerApi } from 'client';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { useHistory } from 'react-router-dom';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';

export const useLoanServices = () => {
	const token = getTokenFromStorage();
	const history = useHistory();
	const loanServices = new LoanControllerApi();

	const errorRedirect = () => {
		history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
	};

	const createLoan = (formData: any, success: Function) => {
		loanServices
			.createLoanLeadUsingPOST(token, formData)
			.then((response) => success(response.data))
			.catch((_err) => errorRedirect());


		//MOCK SERVICES
		// setTimeout(() => {
		// 	success({ knockOut: { status: 'Bueno' }, id: 100, version: 1 });
		// }, 2000);
	};

	const updateLoan = (formData: any, id: number, success: Function) => {
		loanServices
			.updateLoanLeadUsingPATCH(token, id, formData)
			.then((response) => success(response.data))
			.catch((_err) => errorRedirect());
		//MOCK SERVICES
		// setTimeout(() => {
		// 	success({
		// 		id: 658,
		// 		version: 6,
		// 		crmIdentifier: '26940210',
		// 		scoring: { color: 'Verde' },
		// 		indexaSimulation: {
		// 			loanAmount: 3063993,
		// 			installmentAmount: 115370,
		// 			loanTaxes: 24512,
		// 			reliefInsurance: 71697,
		// 			unemploymentInsurance: 201204,
		// 			totalSurchages: 266580,
		// 			interestRate: 1.72,
		// 			vmfg: 0,
		// 			installmentNumber: 36,
		// 			cae: 36.61,
		// 			totalLoanCost: 4153320,
		// 			discountInterestRate: 1.55,
		// 			downPaymentPercentage: 50,
		// 			discountPercentage: 10,
		// 		},
		// 	});
		// }, 4000);
	};

	const createRefinancingLoan = (formData: any, success: Function) => {
		loanServices
			.refinancingUsingPOST(token, formData)
			.then((response) => success(response.data))
			.catch((_err) => errorRedirect());
		//MOCK SERVICES
		// setTimeout(() => {
		// 	success({ knockOut: { status: 'Bueno' }, id: 100, version: 1 });
		// }, 2000);
	};

	return { createLoan, updateLoan, createRefinancingLoan } as const;
};
